import React, { createContext, useContext, useState, useEffect } from "react";
import { GetUserProfile } from "../../services/backendServices";
import { STORAGE_KEYS } from "../../Util/key_helper";
import { encryptData, decryptData } from "../../Util/secureStorage";
// Create a context for ProfileData
const ProfileContext = createContext();
/*** ProfileContextProvider: A provider component to manage and supply profile data*/
export const ProfileContextProvider = ({ children }) => {
    const [profileData, setProfileData] = useState(() => {
        const storedData = localStorage.getItem(STORAGE_KEYS.USER_PROFILE);
        return storedData ? decryptData(storedData) : null;
    });
    const [profileLoading, setProfileLoading] = useState(true);; // State to track profileLoading status for profile data 
    const [refetchProfileData, setRefetchProfileData] = useState(true);  // state to track profile data has been fetched

    // Function to fetch user profile
    const fetchUserProfile = async () => {
        try {
            const res = await GetUserProfile();
            if (res.status) {
                setProfileData(res.data);
                localStorage.setItem(STORAGE_KEYS.USER_PROFILE, encryptData(JSON.stringify(res.data)));
                setRefetchProfileData(false)
            }
        } catch (error) {
            console.error("Error fetching user profile", error);
        } finally {
            setProfileLoading(false);
        }
    };

    useEffect(() => {
        const storredData = localStorage.getItem(STORAGE_KEYS.USER_PROFILE);
        if (storredData) {
            const decryptedData = decryptData(storredData);
            if (decryptedData) {
                setProfileData((prev) => ({ ...prev, ...decryptedData }));
            }
        }

    }, []);
    useEffect(() => {
        if (refetchProfileData) {
            fetchUserProfile();
        }
    }, [refetchProfileData])
    return (
        // The ProfileContext.Provider component provides state and functions to the children components
        <ProfileContext.Provider
            value={{
                profileData, // provides  the user profile data 
                setProfileData, // Provides the function to set/update the profile data
                profileLoading,// Provides the loading state of profile data 
                fetchUserProfile,   // Provides the function to fetch the user profile data
                setRefetchProfileData, //Provides a function to manually update the fetched status
                refetchProfileData, // provides the fetched status of profile data 
            }}>
            {children}
        </ProfileContext.Provider>
    );
};

// Custom hook to use the UserProfileContext
export const UseProfileContext = () => useContext(ProfileContext);
